module.exports = Object.freeze({
  BASE_URL: "https://portalapi.infomate360.com/api/v1/",
  // BASE_URL: "https://devportalapi.infomate360.com/api/v1/",
  // BASE_URL: "http://3.108.38.116:9000/api/v1/",
});
